import styles from "./style.module.css";
import { useContext } from "react";
import UIContext from "../../store/UIContext";
import clsx from "classnames";

export default function Inputs({ nodeComponent, node }) {
  const inputs = Object.values(nodeComponent.inputs);

  const { state: UIState, methods: UIMethods } = useContext(UIContext);

  if (!inputs || !inputs.length) return null;

  return (
    <div
      style={{ display: "flex", flexDirection: "column", alignItems: "start" }}
    >
      {inputs.map((input) => {
        function handleRemoveConnection(e) {
          e.stopPropagation();
          const key = e.key;
          if (key === "Backspace" || key === "Delete") {
            UIMethods.removeInput(`${node.id}:${input.id}`);
          }
        }

        return (
          <div
            key={input.id}
            style={{
              display: "flex",
              gap: "10px",
              position: "relative",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <button
              className={clsx({
                [styles.inputButton]: true,
                [styles.inputButtonActive]:
                  UIState.selectedInput === `${node.id}:${input.id}`,
              })}
              onKeyDown={handleRemoveConnection}
              onClick={() => UIMethods.selectInput(`${node.id}:${input.id}`)}
              id={`${node.id}:${input.id}`}
            ></button>
            <small className={styles.inputName}>{input.name}</small>
          </div>
        );
      })}
    </div>
  );
}
